import "./App.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';

import { ConfigProvider } from "./Context/ConfigContext";
import routes from "./Routes/Routes";
import AppLayout from "./layout/AppLayout";
import PrivateRoute from "./Routes/ProtectedRoutes";
import Page404 from "./layout/Page404";
import Login from "./pages/Login";
import { createHashRouter, RouterProvider } from "react-router-dom";
import Unauthorized from "./pages/Othes/unauthorized";
import TodaysPrint from "./pages/Invoices/TodaysPrint";
import StockPrint from "./pages/Invoices/StockPrint";
import QrDisplayMode from "./Components/QrDisplayMode";
import PromoDisplayMode from "./Components/PromoDisplayMode";

function App() {
  const router = createHashRouter([
    { path: "/login", element: <Login />, },
    { path: "/unauthorized", element: <Unauthorized />, },
    { path: "/Qr", element: <QrDisplayMode /> },
    { path: "/Promo", element: <PromoDisplayMode /> },
    {
      path: "/",
      element: <AppLayout />,
      errorElement: <Page404 />,
      children: routes.map((route) => ({
        ...route,
        element: <PrivateRoute children={route.element} routeName={route.routeName} />,
      })),
    },
    { path: "/TodaysPrint/:store_id?/:from_date?/:to_date?/:encrypted_code?", element: <TodaysPrint />, routeName: 'TodaysPrint' },
    { path: "/StockPrint/:store_id?/:keyword?/:limit?/:order?/:category_id?", element: <StockPrint />, routeName: 'StockPrint' },

  ]);

  return (
    <ConfigProvider>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;